import { useEffect, useState } from 'react';

const useAdminKeySequence = () => {
  const [keySequence, setKeySequence] = useState([]);
  const [isAdminTriggered, setIsAdminTriggered] = useState(false);
  
  const targetSequence = ['a', 'd', 'm', 'i', 'n'];
  const sequenceTimeout = 3000; // 3 seconds to complete sequence

  useEffect(() => {
    let timeoutId;

    const handleKeyPress = (event) => {
      // Only listen for letter keys, ignore modifier keys and special keys
      if (event.key.length === 1 && event.key.match(/[a-zA-Z]/)) {
        const key = event.key.toLowerCase();
        
        setKeySequence(prev => {
          const newSequence = [...prev, key];
          
          // Clear timeout if it exists
          if (timeoutId) {
            clearTimeout(timeoutId);
          }
          
          // Set new timeout to reset sequence
          timeoutId = setTimeout(() => {
            setKeySequence([]);
          }, sequenceTimeout);
          
          // Check if we have the target sequence
          if (newSequence.length >= targetSequence.length) {
            const lastFiveKeys = newSequence.slice(-targetSequence.length);
            const isMatch = lastFiveKeys.every((k, i) => k === targetSequence[i]);
            
            if (isMatch) {
              setIsAdminTriggered(true);
              setKeySequence([]); // Reset sequence
              clearTimeout(timeoutId);
              
              // Auto-reset the trigger after a short delay
              setTimeout(() => {
                setIsAdminTriggered(false);
              }, 100);
              
              return [];
            }
          }
          
          // Keep only last 10 keys to prevent memory issues
          return newSequence.slice(-10);
        });
      }
    };

    // Add event listener to document
    document.addEventListener('keydown', handleKeyPress);

    // Cleanup
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, []);

  // Function to manually reset the trigger
  const resetAdminTrigger = () => {
    setIsAdminTriggered(false);
  };

  return {
    isAdminTriggered,
    resetAdminTrigger,
    currentSequence: keySequence
  };
};

export default useAdminKeySequence;